/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ResultQualityResponse = {
    Found: 'FOUND',
    Potential: 'POTENTIAL'
} as const;
export type ResultQualityResponse = typeof ResultQualityResponse[keyof typeof ResultQualityResponse];


export function instanceOfResultQualityResponse(value: any): boolean {
    for (const key in ResultQualityResponse) {
        if (Object.prototype.hasOwnProperty.call(ResultQualityResponse, key)) {
            // @ts-ignore
            if (ResultQualityResponse[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ResultQualityResponseFromJSON(json: any): ResultQualityResponse {
    return ResultQualityResponseFromJSONTyped(json, false);
}

export function ResultQualityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultQualityResponse {
    return json as ResultQualityResponse;
}

export function ResultQualityResponseToJSON(value?: ResultQualityResponse | null): any {
    return value as any;
}

